<template>
  <div class="all">
    <Nav></Nav>
    <div class="content desktop-present">
      <div class="activity-title">
        <div class="icon"></div>
        首页>>影赛展台
      </div>
      <div class="announce-list">
        <div class="announce-con" v-for="k in activityList" :key="k.id">
          <div class="annoce-title">
            <div class="title">{{ k.title }}</div>
            <div class="sponsor">主办单位：{{ k.sponser }}</div>
          </div>
          <div class="annoce-nav">
            <div class="img" :style="{ backgroundImage: `url(` + k.imgURL + `)` }" @click="onGoActivity(k.id)"></div>
            <div class="text">
              <div class="detail-text" v-html="k.brief"></div>
              <div class="more" @click="onGoActivity(k.id)">活动详情>>></div>
              <div class="time">{{ k.startTime }}&nbsp;&nbsp;--&nbsp;&nbsp;{{ k.stopTime }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content mobile-present">
      <div class="activity-title">
        <div class="icon"></div>
        首页>>影赛展台
      </div>
      <div class="announce-list">
        <div class="announce-con" v-for="k in activityList" :key="k.id">
          <div class="annoce-title">
            <div class="title">{{ k.title }}</div>
            <div class="sponsor">主办单位：{{ k.sponser }}</div>
          </div>
          <div class="annoce-nav">
            <div class="img" :style="{ backgroundImage: `url(` + k.imgURL + `)` }"></div>
            <div class="text">
              <div class="detail-text">{{ k.brief }}</div>
              <div class="more" @click="onGoActivity(k.id)">活动详情>>></div>
              <div class="time">{{ k.startTime }}&nbsp;&nbsp;--&nbsp;&nbsp;{{ k.stopTime }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Bottom></Bottom>
  </div>
</template>

<script>
import RD from '@/api/RD'
import Nav from '@/components/nav.vue'
import Bottom from '@/components/bottom.vue'

export default {
  name: 'Index',
  components: { Nav, Bottom },
  data: function () {
    return {
      activityList: [],
    }
  },
  created() {
    this.reload()
  },
  methods: {
    reload() {
      var thiz = this
      RD.activityTopic()
        .forShow()
        .then((data) => {
          data.forEach((k) => {
            k.imgURL = RD.activityTopic().id(k.id).headPic_URL(0)
          })
          thiz.activityList = data
        })
    },
    onGoActivity(postId) {
      let routerUrl = this.$router.resolve({
        path: '/activityPage.html',
        query: { code: postId },
      })
      window.open(routerUrl.href, '_blank')
    },
  },
}
</script>

<style lang="less" scoped>
.all {
  height: auto;
  .content.desktop-present {
    width: 120rem;
    margin: 0 auto;
    .activity-title {
      height: 4rem;
      text-align: left;
      width: 120rem;
      margin: 0 auto;
      font-size: 1.3rem;
      padding-top: 1.5rem;
      display: flex;
      border-bottom: 0.1rem solid #bfbfbf;
      .icon {
        width: 2rem;
        height: 2rem;
        background: no-repeat url(../assets/weizhi.png);
        background-size: cover;
        margin-right: 1rem;
      }
    }
    .announce-list {
      width: 120rem;
      margin: 1rem auto;
      background: #f5f5f5;
      padding-top: 1rem;
      .announce-con {
        width: 110rem;
        margin: 2rem auto;
        border: 0.1rem solid #ccc;
        padding-bottom: 3rem;
        padding-left: 1rem;
        .annoce-title {
          height: 6rem;
          line-height: 6rem;
          text-align: left;
          margin-top: 1rem;
          font-size: 2rem;
          color: #d80c1d;
          position: relative;
          .title {
            display: inline-block;
          }
          .sponsor {
            width: auto;
            height: 5rem;
            position: absolute;
            right: 1rem;
            top: 0rem;
            color: #000;
            font-size: 1.5rem;
          }
        }
        .annoce-nav {
          height: 22rem;
          display: flex;
          margin-top: 1rem;
          .img {
            width: 30%;
            height: 100%;
            background: no-repeat 50% / cover;
            cursor: pointer;
          }
          .text {
            height: 22rem;
            margin-left: 2rem;
            width: 68%;
            text-align: left;
            line-height: 4rem;
            font-size: 1.4rem;
            text-indent: 2rem;
            .detail-text {
              height: 73%;
              overflow-y: auto;
            }
            .more,
            .time {
              color: #8b8b8b;
              text-align: right;
              margin-right: 1rem;
            }
            .more {
              cursor: pointer;
            }
          }
        }
      }
    }
  }
  .content.mobile-present {
    width: 750px;
    margin: 0 auto;
    .activity-title {
      height: 4rem;
      text-align: left;
      width: 750px;
      margin: 0 auto;
      font-size: 16px;
      padding-top: 1.5rem;
      display: flex;
      border-bottom: 0.1rem solid #bfbfbf;
      .icon {
        width: 2rem;
        height: 2rem;
        background: no-repeat url(../assets/weizhi.png);
        background-size: cover;
        margin-right: 10px;
        margin-top: 8px;
      }
    }
    .announce-list {
      width: 750px;
      margin: 1rem auto;
      background: #f5f5f5;
      padding-top: 1rem;
      .announce-con {
        width: 730px;
        margin: 2rem auto;
        border: 0.1rem solid #ccc;
        padding-bottom: 3rem;
        padding-left: 1rem;
        .annoce-title {
          height: 6rem;
          line-height: 6rem;
          text-align: left;
          margin-top: 1rem;
          font-size: 16px;
          color: #d80c1d;
          position: relative;
          .title {
            display: inline-block;
          }
          .sponsor {
            width: auto;
            height: 5rem;
            position: absolute;
            right: 1rem;
            top: 0rem;
            color: #000;
            font-size: 14px;
          }
        }
        .annoce-nav {
          height: 22rem;
          display: flex;
          margin-top: 1rem;
          .img {
            width: 30%;
            height: 100%;
            background: no-repeat 50% / cover;
            cursor: pointer;
          }
          .text {
            height: 22rem;
            margin-left: 2rem;
            width: 68%;
            text-align: left;
            line-height: 4rem;
            font-size: 1.4rem;
            text-indent: 2rem;
            .detail-text {
              height: 73%;
              overflow-y: auto;
              font-size: 14px;
            }
            .more,
            .time {
              color: #8b8b8b;
              text-align: right;
              margin-right: 1rem;
              font-size: 14px;
            }
            .more {
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
